<template>
  <tbody v-if="Object.keys(batch).length !== 0">
    <tr>
      <td style="width: 55px">
        <font-awesome-icon v-if="openBatch"
          title="Match Process not yet complete."
          class="fa-lg has-text-warning"
          :icon="['fas', 'exclamation-triangle']"
        />
      </td>
      <td>
        <div class="is-flex flex-direction--column">
          <div class="is-flex">
            <router-link
              v-if="hasModule('DRMCH:MATCH:HISTORY:VIEW')"
              :to="{ path: `/directMatch/batch/${batch.id}/details` }"
              class="has-text-weight-bold"
            >
              {{ batch.id }}
            </router-link>
            <div v-else class="has-text-weight-bold">
              {{ batch.id }}
            </div>
            <span v-if="batch.fileName && batch.matchType.code === 'FILE' "
              class="padding-left--small has-text-grey max-width-15"
            >
              {{ batch.fileName }}
            </span>
          </div>
          <div class="is-flex has-text-grey">
            {{ batch.matchType.description }}
          </div>
        </div>
      </td>
      <td>
        <span class="has-text-weight-bold">
          {{ batch.program.description }}
        </span>
      </td>
      <td class="is-hidden-touch">
        <div class="is-flex flex-direction--column">
          <div v-if="!batch.districtCode && !batch.schoolCode" class="is-flex">
            <b style="font-size:14px">
              State Batch
            </b>
          </div>
          <div v-else>
            <router-link
              :to="{
                name: 'DmDistrictInfoDetails',
                params: { code: batch.district.code  },
              }"
              class="has-text-weight-bold has-text-primary" style="font-size:14px"
            >
              {{ batch.district.location.name }}
            </router-link>
            <span class="padding-left--small has-text-grey">
              ({{ batch.district.code }})
            </span>
            <div v-if="batch.school">
              <router-link
                :to="{
                  name: 'DmSchoolInfoDetails',
                  params: {
                    districtCode: batch.district.code,
                    schoolCode: batch.school.code,
                  },
                }"
                class="is-italic"
              >
                {{ batch.school.location.name }}
              </router-link>
              <span class="padding-left--small has-text-grey is-italic">
                ({{ batch.school.code }})
              </span>
            </div>
            <div v-else>
              <span class="is-italic has-text-grey">
                All Schools
              </span>
            </div>
          </div>
        </div>
      </td>
      <td class="is-hidden-mobile">
        <div class="is-flex flex-direction--column">
          <span class="is-flex has-text-weight-bold">
            {{
              new Intl.DateTimeFormat('en', {
                year:'numeric',
                month:'2-digit',
                day:'2-digit',
              })
              .format(new Date(batch.createdDate))
            }}
          </span>
          <span class="has-text-grey">
            {{
              new Intl.DateTimeFormat('en', {
                hour:'numeric',
                minute:'numeric',
              })
              .format(new Date(batch.createdDate))
            }}
          </span>
        </div>
      </td>
      <td>
        <span v-if="openBatch" class="has-text-weight-bold">
          {{ batch.pendingCount }} of {{ batch.recordCount}}
          <div class="has-text-grey">
            PENDING
          </div>
        </span>
        <span v-else class="has-text-weight-bold">
          {{ batch.recordCount}} of {{ batch.recordCount}}
        </span>
      </td>
      <td class="is-hidden-mobile">
        <dm-status-info-icon
          :batchStatus="batch.status"
        />
      </td>
      <td>
        <div class="is-flex flex-justify--end flex-align--center">
          <es-loader v-if="reloading" size="2x"/>
          <a class="is-hidden-mobile" v-else-if="isInternalAction && !action.isHidden" @click="handleInternalCall">
            {{ action.text }}
          </a>
          <router-link class="is-hidden-mobile" v-else-if="!action.isHidden" :to="{ path: action.link }">
            {{ action.text }}
          </router-link>
          <a class="padding-left--1rem" v-if="activeMenu.length">
            <es-menu :setValues="activeMenu" @callMenuAction="callMenuAction"/>
          </a>
        </div>
      </td>
    </tr>
  </tbody>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import DmStatusInfoIcon from '@/components/DmStatusInfoIcon.vue';
import EsLoader from '@/components/EsLoader.vue';
import EsMenu from '@/components/EsMenu.vue';
import PermissionManager from '@/mixins/PermissionManager';

export default {
  mixins: [
    PermissionManager,
  ],
  props: [
    'batchObject',
  ],
  components: {
    DmStatusInfoIcon,
    EsLoader,
    EsMenu,
  },
  data() {
    return {
      batch: null,
      reloading: null,
    };
  },
  created() {
    this.batch = this.batchObject;
  },
  computed: {
    activeMenu() {
      return this.batchCompletedMenu.filter(item => !item.isHidden);
    },
    openBatch() {
      const { status } = this.batch;
      if (status === 'COMPLETED') {
        return false;
      }
      return true;
    },
    batchCompletedMenu() {
      const menuItems = [];
      if (['LOADED', 'QUEUED', 'RUNNING', 'RESTARTING'].includes(this.batch.status) && this.action.text == 'Refresh') {
        menuItems.push({
          id: 0,
          description: 'Refresh',
          isHidden: !this.hasModule('DRMCH:MATCH:HISTORY:VIEW'),
          isInternal: true,
          internalAction: 'refreshBatchRow',
        });
      }
      if (['COMPLETED','COMPLETED_WITH_PENDING','RUNNING','ERRORED','LOADED','QUEUED'].includes(this.batch.status)) {
        menuItems.push({
          id: 1,
          description: 'Download',
          path: `/directmatch/batch/${this.batch.id}/download`,
          isHidden: !this.hasModule('DRMCH:DWNLD:DOWNLOAD'),
        });
      }
      if (this.action.text
        && this.action.text !== 'View'
        && this.action.text !== 'Refresh'
        && this.action.text !== 'Download'
        || ['RUNNING'].includes(this.batch.status)) {
        menuItems.push({
          id: 2,
          description: 'Resolve',
          path: `/directMatch/nearMatches?dmBatchId=${this.batch.id}`,
          isHidden: !this.hasModule('DRMCH:MATCH:RESOLVENM:VIEW'),
        });
      }
      menuItems.push({
        id: 3,
        description: 'View Batch Details',
        path: `/directmatch/batch/${this.batch.id}/details`,
        isHidden: !this.hasModule('DRMCH:MATCH:HISTORY:VIEW'),
      });
      return menuItems;
    },
    isInternalAction() {
      if (this.action.isInternal) {
        return true;
      }
      return false;
    },
    action() {
      // TODO: update links when Near Match page is completed.

      if (['LOADED', 'QUEUED', 'RUNNING', 'RESTARTING'].includes(this.batch.status)) {
        // this is an internal link to call some function.
        return {
          isInternal: true,
          link: '/directMatch',
          internalAction: 'refreshBatchRow',
          text: 'Refresh',
          isHidden: !this.hasModule('DRMCH:MATCH:HISTORY:VIEW'),
        };
      }
      if (['ERRORED_VALIDATION','ERRORED'].includes(this.batch.status)) {
        return {
          link: `/directMatch/batch/${this.batch.id}/details`,
          text: 'View',
          isHidden: !this.hasModule('DRMCH:MATCH:HISTORY:VIEW'),
        };
      }
      if (['COMPLETED_WITH_PENDING','RUNNING'].includes(this.batch.status)) {
        return {
          link: `/directMatch/nearMatches?dmBatchId=${this.batch.id}`,
          text: 'Resolve',
          isHidden: !this.hasModule('DRMCH:MATCH:RESOLVENM:VIEW'),
        };
      }
      return {};
    },
  },
  methods: {
    callMenuAction() {
      this.refreshBatchRow();
    },
    handleInternalCall() {
      this[this.action.internalAction]();
    },
    async refreshBatchRow() {
      try {
        this.reloading = true;
        const res = await axios.get(`directmatch/batches?ids=${this.batch.id}`);
        this.batch = res.data.data[0];
      } catch (e) {
        // handle error
      }
      this.reloading = false;
    },
  },
}
</script>

<style lang="sass" scoped>
  .padding-left--small
    padding-left: 0.25rem
  .padding-left--1rem
    padding-left: 1rem
  .max-width-15
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis
    max-width: 20ch
</style>
